<template>
  <div>
    <div :data-phone="edition" class="col-md-12 px-0 py-0">
      <v-form ref="formcity">
        <v-switch
          v-model="cityInfo.all"
          class="my-3"
          color="indigo darken-3"
          hide-details
          label="کل کشور"
          @change="all($event)"
        />

        <v-autocomplete
          v-if="cityInfo.all !== true"
          v-model="cityInfo.state"
          :clearable="cityInfo.state && cityInfo.state.length > 0"
          :items="states"
          :multiple="true"
          :no-data-text="$t('LISTS.NoData')"
          :required="force"
          chips
          deletable-chips
          clear-icon="mdi-close-circle-outline"
          dense
          item-text="name"
          item-value="id"
          label="استان"
          outlined
          placeholder="نام استان مورد نظر را جستجو کنید."
          small-chips
          :rules="[
            (v) => (!!v && v.length > 0) || 'فیلد استان را نباید خالی بگذارید!',
          ]"
          :error-messages="errorState"
          @change="checkCity($event)"
          @input="getState($event)"
        >
          <template v-slot:prepend-inner>
            <span class="svg-icon svg-icon-primary svg-icon-2x">
              <svg
                height="24px"
                version="1.1"
                viewBox="0 0 24 24"
                width="24px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  fill="none"
                  fill-rule="evenodd"
                  stroke="none"
                  stroke-width="1"
                >
                  <rect height="24" width="24" x="0" y="0" />
                  <path
                    d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </span>
          </template>
        </v-autocomplete>

        <v-autocomplete
          v-if="
            cityInfo.state &&
            cityInfo.state.length === 1 &&
            cityInfo.all !== true
          "
          v-model="cityInfo.city"
          clearable
          :items="city"
          multiple
          :no-data-text="$t('LISTS.NoData')"
          :required="force"
          chips
          deletable-chips
          clear-icon="mdi-close-circle-outline"
          dense
          item-text="name"
          item-value="id"
          label="شهر"
          name="city"
          outlined
          :rules="[
            (v) => (!!v && v.length > 0) || 'فیلد شهر را نباید خالی بگذارید!',
          ]"
          placeholder="نام شهر مورد نظر را جستجو کنید."
          small-chips
          :error-messages="errorCity"
          @change="checkNeighbor($event)"
          @input="getCity($event)"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip
              v-if="index === 0 && cityInfo.city.length === city.length"
              small
              close
              @click:close="cityInfo.city = []"
            >
              همه شهرها
            </v-chip>
            <v-chip
              v-else-if="cityInfo.city.length !== city.length"
              small
              close
              @click:close="
                cityInfo.city = cityInfo.city.filter((id) => id !== item.id)
              "
            >
              {{ item.name }}
            </v-chip>
          </template>
          <template v-slot:prepend-inner>
            <span class="svg-icon svg-icon-primary svg-icon-2x">
              <svg
                height="24px"
                version="1.1"
                viewBox="0 0 24 24"
                width="24px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  fill="none"
                  fill-rule="evenodd"
                  stroke="none"
                  stroke-width="1"
                >
                  <rect height="24" width="24" x="0" y="0" />
                  <path
                    d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="all_cities" @mousedown.prevent>
              <v-list-item-action>
                <v-icon color="indigo darken-4">
                  {{ icon_city }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>انتخاب همه</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>

        <div v-if="neighborhood.length > 0 && cityInfo.all !== true">
          <v-autocomplete
            id="neighborhood"
            v-model="cityInfo.neighborhood"
            :items="neighborhood"
            clearable
            :loading="loading"
            :multiple="true"
            :no-data-text="$t('LISTS.NoData')"
            :placeholder="
              loading
                ? $t('DIALOGS.Waiting')
                : 'نام محله مورد نظر را جستجو کنید.'
            "
            :readonly="neighborhood.length === 0 || loading"
            :rules="[
              (v) =>
                neighborhood.length === 0 ||
                (v && v.length > 0) ||
                'فیلد محله را نباید خالی بگذارید!',
            ]"
            :required="force"
            chips
            deletable-chips
            clear-icon="mdi-close-circle-outline"
            dense
            item-text="name"
            item-value="id"
            label="محله"
            name="neighborhood"
            outlined
            :error-messages="errorNeighbor"
            small-chips
            @input="getNeighbor($event)"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="
                  index === 0 &&
                  cityInfo.neighborhood.length === neighborhood.length
                "
                small
                close
                @click:close="cityInfo.neighborhood = []"
              >
                همه محله‌ها
              </v-chip>
              <v-chip
                v-else-if="cityInfo.neighborhood.length !== neighborhood.length"
                small
                close
                @click:close="
                  cityInfo.neighborhood = cityInfo.neighborhood.filter(
                    (id) => id !== item.id
                  )
                "
              >
                {{ item.name }}
              </v-chip>
            </template>
            <template v-slot:prepend-inner>
              <span class="svg-icon svg-icon-primary svg-icon-2x">
                <svg
                  height="24px"
                  version="1.1"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="none"
                    stroke-width="1"
                  >
                    <rect height="24" width="24" x="0" y="0" />
                    <path
                      d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                      fill="#000000"
                    />
                  </g>
                </svg>
              </span>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="all_neighborhood" @mousedown.prevent>
                <v-list-item-action>
                  <v-icon color="indigo darken-4">
                    {{ icon_neighborhood }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>انتخاب همه</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { Bus } from "@/main";
import axios from "axios";

export default {
  name: "citySelector",
  props: {
    force: { type: Boolean, default: false },
    defaultEdit: { type: Boolean, default: false },
    editCity: { type: Object, default: () => ({ city: [], neighborhood: [] }) },
    MultiCity: { type: Boolean, default: false },
    auto_change: { type: Boolean, default: false },
  },
  data() {
    return {
      city: [],
      states: [],
      neighborhood: [],
      errorCity: "",
      loading: false,
      errorNeighbor: "",
      errorState: "",
      cityInfo: {
        all: false,
        city: [],
        neighborhood: "",
        state: [],
        all_n: false,
      },
    };
  },
  computed: {
    icon_city() {
      if (this.city && Array.isArray(this.city)) {
        if (this.cityInfo.city.length === this.city.length) {
          return "mdi-close-box";
        }
        if (
          this.cityInfo.city.length > 0 &&
          this.cityInfo.city.length < this.city.length
        ) {
          return "mdi-minus-box";
        }
        return "mdi-checkbox-blank-outline";
      }
      return "mdi-checkbox-blank-outline";
    },
    icon_neighborhood() {
      if (
        this.neighborhood &&
        Array.isArray(this.neighborhood) &&
        this.neighborhood.length > 0
      ) {
        if (this.cityInfo.neighborhood.length === this.neighborhood.length) {
          return "mdi-close-box";
        }
        if (
          this.cityInfo.neighborhood.length > 0 &&
          this.cityInfo.neighborhood.length < this.neighborhood.length
        ) {
          return "mdi-minus-box";
        }
        return "mdi-checkbox-blank-outline";
      }
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {
    this.getStates();
    if (this.defaultEdit && this.editCity) {
      this.edition();
    }
  },
  methods: {
    edition() {
      // this.cityInfo.city = [...this.editCity.city];
      // this.cityInfo.neighborhood = [...this.editCity.neighborhood];
      // if (this.editCity.neighborhood.length > 0) {
      //   this.checkNeighbor(this.editCity.city);
      // }
    },
    requestApiGet(uri, queries = {}, serializer = null) {
      return axios.get(`${this.$robotApi}/${uri}`, {
        headers: this.header(),
        params: queries,
        paramsSerializer: serializer,
      });
    },
    header() {
      return {
        Authorization: Token ? `Bearer ${Token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    getStates() {
      this.requestApiGet("divar/cities")
        .then(({ data }) => {
          this.states = data.data || [];
        })
        .catch((error) => {
          console.error("Error fetching states:", error);
          this.states = [];
        });
    },
    checkCity($event) {
      let queryParams = "";
      if ($event && $event.length > 0) {
        queryParams = $event.map((id) => `citi_id[]=${id}`).join("&");
        this.requestApiGet(`divar/cities/parts?${queryParams}`)
          .then(({ data }) => {
            this.city = data.data
              ? data.data
                  .filter((x) => typeof x.id === "number")
                  .map((x) => ({ ...x, id: x.id.toString() }))
              : [];
            // Pre-select all cities
            this.cityInfo.city = this.city.map((c) => c.id.toString());
            this.checkNeighbor(this.cityInfo.city);
          })
          .catch((error) => {
            console.error("Error fetching city parts:", error);
            this.city = [];
            this.cityInfo.city = [];
            this.neighborhood = [];
            this.cityInfo.neighborhood = [];
          });
      } else {
        this.city = [];
        this.cityInfo.city = [];
        this.neighborhood = [];
        this.cityInfo.neighborhood = [];
      }
    },
    checkNeighbor(cityIds) {
      this.loading = true;
      if (!cityIds || cityIds.length === 0) {
        this.neighborhood = [];
        this.cityInfo.neighborhood = [];
        this.loading = false;
        return;
      }
      const promises = cityIds.map((cityId) =>
        axios.get(`${url}/divar/districts/${cityId}`, {
          headers: {
            Authorization: Token,
            Accept: "application/json",
          },
        })
      );
      Promise.all(promises)
        .then((results) => {
          this.neighborhood = [];
          results.forEach((result) => {
            if (result.data && result.data.data) {
              this.neighborhood = [...this.neighborhood, ...result.data.data];
            }
          });
          this.cityInfo.neighborhood = this.neighborhood.map((i) => i.id);
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error fetching neighborhoods:", error);
          this.neighborhood = [];
          this.cityInfo.neighborhood = [];
          this.loading = false;
        });
    },
    getNeighbor(val) {
      this.cityInfo.neighborhood = Array.isArray(val)
        ? val.map((item) =>
            typeof item === "Object"
              ? item.id
              : typeof item === "number"
              ? item
              : item
          )
        : [val?.toString() || ""];
    },
    getCity(val) {
      if (!val) {
        this.cityInfo.city = [];
      } else {
        this.cityInfo.city = Array.isArray(val)
          ? val.map((item) =>
              typeof item === "number" ? item.toString() : item
            )
          : [val.toString()];
      }
      if (this.cityInfo.city.length > 0) {
        this.checkNeighbor(this.cityInfo.city);
      } else {
        this.neighborhood = [];
        this.cityInfo.neighborhood = [];
      }
    },
    getState(val) {
      this.cityInfo.state = val;
      this.cityInfo.city = [];
      this.cityInfo.neighborhood = [];
      this.checkCity(val);
    },
    all($event) {
      if ($event) {
        this.cityInfo.all = true;
        this.cityInfo.state = [];
        this.cityInfo.city = this.states.flatMap(
          (state) => state.children?.map((city) => city.id.toString()) || []
        );
        this.cityInfo.neighborhood = [];
      } else {
        this.cityInfo.all = false;
        this.cityInfo.city = [];
        this.cityInfo.neighborhood = [];
      }
    },
    all_cities() {
      this.$nextTick(() => {
        if (this.cityInfo.city.length === this.city.length) {
          this.cityInfo.city = [];
        } else {
          this.cityInfo.city = this.city.map((item) => item.id.toString());
        }
        this.checkNeighbor(this.cityInfo.city);
      });
    },
    all_neighborhood() {
      this.$nextTick(() => {
        if (this.cityInfo.neighborhood.length === this.neighborhood.length) {
          this.cityInfo.neighborhood = [];
        } else {
          this.cityInfo.neighborhood = this.neighborhood.map((i) =>
            i.id.toString()
          );
        }
      });
    },
    validate() {
      let validate = true;
      let message = "";
      let errors = [];
      if (!!this.cityInfo && this.cityInfo.all) return true;
      if (!this.cityInfo.state || this.cityInfo.state.length === 0) {
        this.errorState = "فیلد استان را نباید خالی بگذارید!";
        errors.push(this.errorState);
        validate = false;
      } else if (!this.cityInfo.city || this.cityInfo.city.length === 0) {
        this.errorCity = "فیلد شهر را نباید خالی بگذارید!";
        validate = false;
        errors.push(this.errorCity);
      } else if (
        (this.neighborhood.length > 0 && !this.cityInfo.neighborhood) ||
        this.cityInfo.neighborhood.length === 0
      ) {
        this.errorNeighbor = "فیلد محله را نباید خالی بگذارید!";
        validate = false;
        errors.push(this.errorNeighbor);
      }
      message += errors.join("\n");
      if (!this.$refs.formcity.validate())
        this.$toast.error(message, { timeout: 5000 });

      return validate;
    },
  },
  watch: {
    cityInfo: {
      handler(val) {
        const data_for_sending = {
          all: val.all,
          all_n: val.all_n,
          city: val.city || [],
          neighborhood: val.neighborhood || [],
        };
        Bus.$emit("cityInfo", data_for_sending);
      },
      deep: true,
    },
  },
};
</script>
<style scoped></style>
